import React, { useEffect, useState } from 'react';
import IECModuleForm from './IECModuleForm';
import { useSearchParams } from 'react-router-dom';
import { getIecData } from '../../Store/IECModule/IECModuleSelector';
import { useSelector } from 'react-redux';

const UpdateIECModule = ({iecId}) => {
  const [serachParams] = useSearchParams();
  const iecDataId = serachParams.get('update');
  const fetchedData = useSelector(getIecData);
  const [videoData, setVideoData] = useState(null);
  useEffect(() => {
    if (iecDataId) {
      const id = parseInt(iecDataId);
      setVideoData(fetchedData.find((data) => data.id === id));
    }
  }, [iecDataId,fetchedData]);
  if (!iecDataId || !videoData) return null;
  return <IECModuleForm data={videoData} updateId={iecId} />;
};

export default UpdateIECModule;
